import { useState } from "react";
import { useTranslation } from "react-i18next";
import "./CompanyAvatar.css";

interface CompanyAvatarProps {
  src?: string | null;
  name?: string | null;
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

function initialsFor(name?: string | null): string {
  if (!name) return "";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

const CompanyAvatar = ({ src, name, size = "md", className }: CompanyAvatarProps) => {
  const { t } = useTranslation("components");
  const [errored, setErrored] = useState(false);
  const showImage = !!src && !errored;
  const initials = initialsFor(name);
  const cls = `company-avatar company-avatar--${size}${className ? ` ${className}` : ""}`;

  if (showImage) {
    return (
      <span className={cls}>
        <img
          src={src ?? undefined}
          alt={name ? t("companyAvatar.logoAlt", { name }) : t("companyAvatar.logoAltFallback")}
          className="company-avatar__img"
          onError={() => setErrored(true)}
        />
      </span>
    );
  }

  return (
    <span
      className={cls}
      aria-label={name ? t("companyAvatar.initialsLabel", { name }) : t("companyAvatar.fallbackLabel")}
    >
      {initials ? (
        <span className="company-avatar__initials">{initials}</span>
      ) : (
        <i className="fa-solid fa-building" aria-hidden />
      )}
    </span>
  );
};

export default CompanyAvatar;
